module.exports = __webpack_public_path__ + "img/tb-02@2x.78a8d38e.png";